import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rankLabel',
  standalone: true
})
export class RankLabelPipe implements PipeTransform {
  transform(rank: number | null | undefined): string {
    if (rank === 1) return '#1 Best Match';
    if (rank === 2) return '#2';
    if (rank === 3) return '#3';
    return '';
  }
}
